$('#resource-results').on('click', '.card', function(e) {
    var title = $(this).find('.card-title').html();

    dataLayer.push({
        'event' : 'resourceClick',
        'event_category': 'Resource',
        'event_label': title,
    });
});

$('#best-practices').on('click', '.card', function(e) {
    var title = $(this).find('.card-title').html();

    dataLayer.push({
        'event' : 'bestPractice',
        'event_category': 'Best Practice',
        'event_label': title,
    });
});

$('#accordionFAQ .topic-header .topic-toggle.collapsed').on('click', function() {
    var label = $(this).data('label'),
        ID = $(this).data('id');

    dataLayer.push({
        'event' : 'FAQ',
        'event_category': 'FAQ',
        'event_label': label,
        'value': ID
    });
});

